/**
 * Created by andrey on 21.05.2020
 */

const BoostersBeforeComponent = function (boosters, lanternStart) {
    const styles = cleverapps.styles.BoostersBeforeComponent;

    let font = cleverapps.styles.FONTS.WINDOW_BIG_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT;
    if (cleverapps.config.features.includes("lantern_start")) {
        font = cleverapps.styles.FONTS.BOOSTERS_BEFORE_TEXT;
    }
    const title = cleverapps.UI.generateOnlyText(
        Messages.get("BoostersBeforeComponent.Title"),
        font
    );

    const views = boosters.list.map((booster) => new BoosterBeforeView(booster, boosters.level));

    const boostersViews = new cleverapps.Layout(views, {
        padding: styles.boostersPadding,
        margin: lanternStart ? styles.lantern.boostersMargin : styles.boostersMargin,
        direction: cleverapps.UI.HORIZONTAL
    });

    if (cleverapps.config.features.includes("lantern_start")) {
        boostersViews.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            cleverapps.effects.fireAction("boosters_before.appear")
        ));
    }
    views.forEach((view, index) => {
        if (cleverapps.config.features.includes("lantern_start")) {
            view.showUp(0.2, true);
        } else {
            view.showUp(0.2 + index * 0.2);
        }
    });

    const content = new cleverapps.Layout([title, boostersViews], {
        margin: lanternStart ? styles.lantern.contentMargin : styles.contentMargin,
        direction: cleverapps.UI.VERTICAL
    });

    const hasLantern = boosters.list.some((booster) => booster.isLantern());

    const lantern = typeof Lantern !== "undefined" && Lantern.Get();

    if (hasLantern && lantern && !lanternStart) {
        const view = new LanternView(lantern, content);
        content.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.CallFunc(() => {
                view.show();
            }),
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                view.replaceParentSamePlace(cleverapps.focusManager.currentWindow());
                view.setLocalZOrder(20);
            }),
            new cc.DelayTime(0.6),
            new cc.CallFunc(() => {
                view.hide();
            })
        ));
    }

    return content;
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BOOSTERS_BEFORE_TEXT: {
        size: 40,
        color: new cc.Color(220, 110, 70, 255)
    }
});

cleverapps.styles.BoostersBeforeComponent = {
    boostersPadding: {
        bottom: 20
    },
    contentMargin: 50,
    lantern: {
        boostersMargin: 25,
        contentMargin: 30
    },
    boostersMargin: 25
};